import React, { useState } from 'react';
import { Col, Collapse, Container, Row, Button } from 'reactstrap';
import classnames from "classnames";
import { useTranslation } from 'react-i18next';
import { appName } from "../../Components/constants/default";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { authUserManager } from "../../helpers/api_helper";

const Faqs = () => {
  const { t } = useTranslation();
  const eventId = authUserManager.getAdminEventId();

  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(false);
  const [col6, setcol6] = useState(false);
  const [col7, setcol7] = useState(false);
  const [col8, setcol8] = useState(false);
  const [col9, setcol9] = useState(false);
  const [col10, setcol10] = useState(false);
  const [col11, setcol11] = useState(false);
  const [col12, setcol12] = useState(false);
  const [col13, setcol13] = useState(false);
  const [col14, setcol14] = useState(false);
  const [col15, setcol15] = useState(false);

  const t_col1 = () => {
    setcol1(!col1);
  };

  const t_col2 = () => {
    setcol2(!col2);
  };

  const t_col6 = () => {
    setcol6(!col6);
    setcol7(false);
    setcol8(false);
    setcol10(false);
    setcol11(false);
    setcol13(false);
    setcol15(false);
  };

  const t_col7 = () => {
    setcol7(!col7);
    setcol6(false);
    setcol8(false);
    setcol10(false);
    setcol11(false);
    setcol13(false);
    setcol15(false);
  };

  const t_col8 = () => {
    setcol8(!col8);
    setcol6(false);
    setcol7(false);
    setcol10(false);
    setcol11(false);
    setcol13(false);
    setcol15(false);
  };

  const t_col9 = () => {
    setcol9(!col9);
    setcol12(false);
  };

  const t_col12 = () => {
    setcol9(false);
    setcol12(!col12);
  };

  const t_col10 = () => {
    setcol10(!col10);
    setcol6(false);
    setcol7(false);
    setcol8(false);
    setcol11(false);
    setcol13(false);
    setcol15(false);
  };

  const t_col11 = () => {
    setcol11(!col11);
    setcol6(false);
    setcol7(false);
    setcol8(false);
    setcol10(false);
    setcol13(false);
    setcol15(false);
  };

  const t_col13 = () => {
    setcol13(!col13);
    setcol6(false);
    setcol7(false);
    setcol8(false);
    setcol10(false);
    setcol11(false);
    setcol14(false);
    setcol15(false);
  };

  const t_col14 = () => {
    setcol14(!col14);
    setcol6(false);
    setcol7(false);
    setcol8(false);
    setcol10(false);
    setcol11(false);
    setcol13(false);
    setcol15(false);
  };

  const t_col15 = () => {
    setcol15(!col15);
    setcol6(false);
    setcol7(false);
    setcol8(false);
    setcol10(false);
    setcol11(false);
    setcol13(false);
    setcol14(false);
  };

  document.title = t('Help') + ' | ' + appName;

  return (
    <React.Fragment>
      <div className="page-content non-admin-layout">
        <Container fluid>
          <BreadCrumb
            title={t('Help')}
            pageTitle={t('Event View')}
            link={"/admin/event/" + eventId}
          />
          <Row>
            <Col lg={12}>
              <Row className="justify-content-evenly mb-4">
                <Col lg={4}>
                  <div className="mt-3">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-shrink-0 me-1">
                        <i className="ri-question-line fs-24 align-middle text-success me-1"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="fs-16 mb-0 fw-semibold">
                          {t('General Questions')}
                        </h5>
                      </div>
                    </div>

                    <div
                      className="accordion accordion-border-box"
                      id="genques-accordion"
                    >
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="genques-headingOne"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col1 }
                            )}
                            type="button"
                            onClick={t_col1}
                            style={{ cursor: "pointer" }}
                          >
                            {t('How to start?')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col1}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body pt-2">
                            <strong>1. </strong>
                            {t(
                              'Print your unique QR code and share it with your event guests or post it on your social media. You can find the code on the main toolbar in the top right corner'
                            )}{' '}
                            (<i className="bx bx-qr"></i>).{' '}
                            {t(
                              'To download the code, right-click on it → Save image as…'
                            )}
                            <p></p>
                            {t(
                              'We can also send you a ready, visually appealing label with the code for your guests - just contact us via the contact form on site'
                            )}
                            :{' '}
                            <a
                              className="link-primary"
                              href={process.env.REACT_APP_API_PUBLIC_URL}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {process.env.REACT_APP_API_PUBLIC_URL}
                            </a>{' '}
                            {t('or email us directly at')}{' '}
                            <a
                              href="mailto:tomasz.hliwiadczyn@gmail.com"
                              className="link-primary"
                            >
                              tomasz.hliwiadczyn@gmail.com
                            </a>
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>2. </strong>
                            {t('Log in to the application')} ->{' '}
                            <a
                              className="link-primary"
                              href={
                                process.env.REACT_APP_API_PUBLIC_URL +
                                '/admin/login'
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {process.env.REACT_APP_API_PUBLIC_URL +
                                '/admin/login'}
                            </a>
                            .{' '}
                            {t(
                              'On the main event screen, click'
                            )}{' '}
                            <Button
                              color="danger"
                              className="custom-toggle btn-sm pe-none pt-0 pb-0"
                            >
                              <span className="icon-on">
                                <i className="ri-play-fill align-bottom me-1"></i>
                                <span className="pb-2">
                                  {t('Start Event')}
                                </span>
                              </span>
                            </Button>{' '}
                            {t(
                              'button to open the event. From that moment, your guests can join and add songs to the list or vote — depending on the event mode. All that’s left for you is to remove the songs that have already been played.'
                            )}
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>3. </strong>
                            <strong>{t('Important!')}</strong>{' '}
                            {t(
                              'After the event is over, make sure to click the'
                            )}{' '}
                            <Button
                              color="danger"
                              className="custom-toggle btn-sm active pe-none pt-0 pb-0"
                            >
                              <span className="icon-of">
                                <i className="ri-stop-fill align-bottom me-1"></i>
                                <span className="pb-2">
                                  {t('End Event')}
                                </span>
                              </span>
                            </Button>
                            .{t(' ')}
                            {t(
                              'It clears all registered users from the event, preventing situations where usernames remain occupied and your guests can’t join future events easily.'
                            )}
                          </div>
                        </Collapse>
                      </div>
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="privacy-headingTwo"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col2 }
                            )}
                            type="button"
                            onClick={t_col2}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Main toolbar icons')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col2}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <ol className="ps-0">
                              <li className="list-group-item">
                                <strong>- {t('Profile Icon')}</strong> -{' '}
                                {t(
                                  'Account settings, application settings'
                                )}
                                .
                              </li>
                              <li className="list-group-item">
                                <strong>- {t('Flag Icon')}</strong> -{' '}
                                {t(
                                  'Allows changing the application’s language'
                                )}
                                .
                              </li>
                              <li className="list-group-item">
                                <strong>- {t('QR Code Icon')}</strong> -{' '}
                                {t(
                                  'Allows displaying the event’s QR code. This enables a user registered for the event to share the code with others without needing a physical copy.'
                                )}
                              </li>
                            </ol>
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mt-3">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-shrink-0 me-1">
                        <i className="ri-team-line fs-24 align-middle text-success me-1"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="fs-16 mb-0 fw-semibold">
                          {t('Manage Event')}
                        </h5>
                      </div>
                    </div>

                    <div
                      className="accordion accordion-border-box text-secondary"
                      id="manageaccount-accordion"
                    >
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingTwo"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col6 }
                            )}
                            type="button"
                            onClick={t_col6}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Which event mode should I choose?')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col6}
                          className="accordion-collapse "
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'To select a mode, click on the bar with the event name located below the main toolbar. You will find a field there labeled “Type”'
                              )}{' '}
                              {t('Available settings')}:
                            </p>

                            <strong>1. {t('Karaoke')}</strong> -{' '}
                            {t(
                              'guests add their songs to the list on a first come, first served basis'
                            )}{' '}
                            (
                            <button
                              className="btn btn-label btn-success color-primary btn-sm pe-none pt-0 pb-0"
                            >
                              <i className="ri-add-circle-line label-icon align-middle fs-16 me-2"></i>
                              {t('Add Song To List')}
                            </button>
                            ).{' '}
                            {t(
                              'The earliest added songs appear at the top of the list. Both you and your guests can see the same list, so everyone knows when it’s their turn.'
                            )}{' '}
                            {t(
                              'In this mode, the nickname of the person who added the song is displayed below the title and artist. Additionally, each participant can add a note for the host (e.g., backing track version, key, etc.) by clicking the envelope button'
                            )}{' '}
                            <i className="ri-mail-add-line align-bottom"></i>{' '}
                            {t('next to the song, and confirming with the plus button.')}
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              2. {t('Dance Party / Concert')}
                            </strong>{' '}
                            -{' '}
                            {t(
                              'guests add songs in a ranking format.Songs with the highest number of votes are displayed higher on the list. Users can both add new songs and vote for those already added by others'
                            )}{' '}
                            (
                            <button
                              style={{ height: '18px' }}
                              className="btn btn-warning waves-effect waves-light btn-icon btn-sm pe-none pt-0 pb-0"
                            >
                              <i className="ri-thumb-up-line"></i>
                            </button>
                            ).{' '}
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              3. {t('Dance Party / Concert (Closed List)')}
                            </strong>{' '}
                            -{' '}
                            {t(
                              'works the same way, except guests can only vote for songs predefined by you.'
                            )}{' '}
                            (
                            <button className="btn btn-label btn-success color-primary btn-sm pe-none pt-0 pb-0">
                              <i className="ri-add-circle-line label-icon align-middle fs-16 me-2"></i>
                              {t('Add Song To List')}
                            </button>
                            ){' '}
                            {t(
                              'button is visible only to you; guests can vote only.'
                            )}
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              {t(
                                'For each mode, you can control the number and frequency of tracks added by guests – depending on the number of participants or your own preferences.'
                              )}
                            </strong>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingThree"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col7 }
                            )}
                            type="button"
                            onClick={t_col7}
                            style={{ cursor: "pointer" }}
                          >
                            {t('How to adjust event settings?')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col7}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'To adjust settings, click on the bar with the event name located below the main toolbar'
                              )}{' '}
                              {t('Available settings depending on the event mode')}:
                            </p>

                            <strong>1. {t('Karaoke')}</strong>
                            <ol className="ps-2">
                              <li className="list-group-item">
                                <strong>
                                  - {t('Track list limit')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'when the number of tracks on the list reaches the set limit, users will no longer be able to add new tracks.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Per-user track limit')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'when a specific user reaches the set number of tracks, they will not be able to add any more.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Consecutive track limit per user')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'the maximum number of tracks a user can have next to each other on the list.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Allow duplicates on the list')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'disabling this option prevents different users from adding the same track to the list.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Allow adding tracks to the list')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'disabling this option will prevent users from adding new tracks. Button'
                                )}{' '}
                                <button className="btn btn-label btn-success color-primary btn-sm pe-none pt-0 pb-0">
                                  <i className="ri-add-circle-line label-icon align-middle fs-16 me-2"></i>
                                  {t('Add Song To List')}
                                </button>{' '}
                                {t('will disappear.')}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('List partially hidden for guests')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ List partially hidden for guests Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Number of songs visible to guests')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Number of songs visible to guests Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Song Library')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'allows you to select a custom song library for your event. When a library is selected, guests can only choose songs from that library. When no library is selected (default), guests can choose from all songs in the global library.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Allow Guests Add Songs From Database Outside')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Allow Guests Add Songs From Database Outside Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Load Full Song Database')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'Load Full Song Database Tooltip'
                                )}
                              </li>
                            </ol>
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              2. {t('Dance Party / Concert')}
                            </strong>
                            <ol className="ps-2">
                              <li className="list-group-item">
                                <strong>
                                  - {t('Track list limit')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'when the number of tracks on the list reaches the set limit, users will no longer be able to add new tracks. However, users will still be able to vote for tracks already on the list.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Vote limit per user')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'the maximum number of votes/suggestions each user can cast for tracks.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Allow adding tracks to the list')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'disabling this option will prevent users from adding new tracks or voting. Button'
                                )}{' '}
                                <button className="btn btn-label btn-success color-primary btn-sm pe-none pt-0 pb-0">
                                  <i className="ri-add-circle-line label-icon align-middle fs-16 me-2"></i>
                                  {t('Add Song To List')}
                                </button>{' '}
                                {t('will disappear.')}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('List partially hidden for guests')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ List partially hidden for guests Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Number of songs visible to guests')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Number of songs visible to guests Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Song Library')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'allows you to select a custom song library for your event. When a library is selected, guests can only choose songs from that library. When no library is selected (default), guests can choose from all songs in the global library.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Allow Guests Add Songs From Database Outside')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Allow Guests Add Songs From Database Outside Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Load Full Song Database')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'Load Full Song Database Tooltip'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Required tip')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Required tip Description'
                                )}
                              </li>
                            </ol>
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              3. {t('Dance Party / Concert (Closed List)')}
                            </strong>
                            <ol className="ps-2">
                              <li className="list-group-item">
                                <strong>
                                  - {t('Vote limit per user')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'the maximum number of votes/suggestions each user can cast for tracks.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('List partially hidden for guests')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ List partially hidden for guests Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Number of songs visible to guests')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Number of songs visible to guests Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Song Library')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'allows you to select a custom song library for your event. When a library is selected, guests can only choose songs from that library. When no library is selected (default), guests can choose from all songs in the global library.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Allow Guests Add Songs From Database Outside')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Allow Guests Add Songs From Database Outside Description'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Load Full Song Database')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'Load Full Song Database Tooltip'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Required tip')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'FAQ Required tip Description'
                                )}
                              </li>
                            </ol>
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              {t(
                                'You can adjust the limits during the event to match the number of guests. However, changing the event mode while it’s in progress is not recommended. To change the mode, click'
                              )}{' '}
                              <Button
                                color="danger"
                                className="custom-toggle btn-sm active pe-none pt-0 pb-0"
                              >
                                <span className="icon-of">
                                  <i className="ri-stop-fill align-bottom me-1"></i>
                                  <span className="pb-2">
                                    {t('End Event')}
                                  </span>
                                </span>
                              </Button>{' '}
                              {t(
                                'if your event has already started.'
                              )}
                            </strong>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingFour"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col8 }
                            )}
                            type="button"
                            onClick={t_col8}
                            style={{ cursor: "pointer" }}
                          >
                            {t('How to search for and add tracks to the list?')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col8}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <strong>
                              {t(
                                'The track search tool is available after clicking the'
                              )}{' '}
                              <button className="btn btn-label btn-success color-primary btn-sm pe-none pt-0 pb-0">
                                <i className="ri-add-circle-line label-icon align-middle fs-16 me-2"></i>
                                {t('Add Song To List')}
                              </button>{' '}
                              {t(
                                'button, on the main event screen'
                              )}
                            </strong>
                          </div>
                          <div className="accordion-body pt-2">
                            <strong>
                              1. {t('Guest Perspective')}
                            </strong>
                            <p>
                              {t(
                                'In this mode, when a user first accesses the event link, they will be prompted to enter a nickname. After entering and confirming the nickname, they will be redirected to the main event screen, where they will see the track list and be able to add new tracks and vote.'
                              )}
                            </p>
                            <p>
                              {t(
                                'After clicking the button, a search window opens. Type in the search field at the top — matching tracks appear in the list below. To add a track, simply click the plus button'
                              )}{' '}
                              <i className="ri-add-circle-line align-bottom"></i>{' '}
                              {t('next to it — the track is added to the list immediately.')}
                            </p>
                            <p>
                              {t(
                                'To add a track with a dedication, click the envelope button'
                              )}{' '}
                              <i className="ri-mail-add-line align-bottom"></i>{' '}
                              {t(
                                'next to the track. A dedication field will appear — enter the dedication and then click the plus button to add the track together with it. The dedication is kept even if you collapse the field, until you clear it.'
                              )}
                            </p>
                            <p>
                              <strong>{t('Editing a track that is already on the list')}</strong>
                            </p>
                            <p>
                              {t(
                                'A guest can still correct their own request. The pencil button'
                              )}{' '}
                              <i className="ri-pencil-line align-bottom"></i>{' '}
                              {t(
                                'swaps the track for another one, and the envelope button'
                              )}{' '}
                              <i className="ri-mail-add-line align-bottom"></i>{' '}
                              {t(
                                'adds or changes the dedication. Both appear only from the second position on the list downwards - the first track is the one about to be played, so it can no longer be changed.'
                              )}
                            </p>
                            <p>
                              {t(
                                'Swapping the track keeps its place in the queue, its dedication and a tip that has already been paid - the guest does not pay again. Leaving the dedication field empty removes the dedication.'
                              )}
                            </p>
                            <p>
                              {t(
                                'If the desired track is not found in the database, the text you typed appears as the first item on the list under the'
                              )}{' '}
                              <strong>"{t('Add new')}"</strong>{' '}
                              {t(
                                'heading. Click the plus button next to it to add it manually — just keep the format'
                              )}{' '}
                              <strong>"{t('Artist - Title')}"</strong>.
                            </p>
                          </div>
                          <div className="accordion-body pt-0">
                            <strong>
                              2. {t('Admin Perspective')}
                            </strong>
                            <p>
                              {t(
                                'In the admin view, the dedication button is not shown. Instead, after clicking the plus button'
                              )}{' '}
                              <i className="ri-add-circle-line align-bottom"></i>{' '}
                              {t(
                                'next to a track, a user selection field opens right below that track. This is a dropdown list of guests already registered for the event — as the administrator you can add a track on behalf of any of them.'
                              )}
                            </p>
                            <p>
                              {t(
                                'You can also add a new user, for example if one of your guests doesn’t have a phone. Just type a name that hasn’t been taken yet and confirm with the “Click to add …” message. Then confirm adding the track by clicking the save button'
                              )}{' '}
                              <i className="ri-check-line align-bottom"></i>{' '}
                              {t('next to the field.')}
                            </p>
                            <p>
                              {t('By default, the track is added in your own name.')}
                            </p>
                            <p>
                              {t(
                                'A track with a dedication is marked with a note button'
                              )}{' '}
                              <i className="ri-sticky-note-line align-bottom"></i>{' '}
                              {t(
                                'in your view - clicking it opens a window with the full text. In standard mode several guests can request the same track and each of them may attach their own dedication, so the window shows all of them at once.'
                              )}
                            </p>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingFive"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col10 }
                            )}
                            type="button"
                            onClick={t_col10}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Tips and Payments')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col10}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              <strong>{t('For Guests')}:</strong>
                            </p>
                            <p>
                              {t(
                                'Next to the button'
                              )}{' '}
                              <button className="btn btn-label btn-success color-primary btn-sm pe-none pt-0 pb-0">
                                <i className="ri-add-circle-line label-icon align-middle fs-16 me-2"></i>
                                {t('Add Song To List')}
                              </button>{' '}
                              {t(
                                'guests can see a tips button. By clicking it, they can make a payment using BLIK directly through the application.'
                              )}
                            </p>
                            <p>
                              <strong>{t('For Event Hosts')}:</strong>
                            </p>
                            <p>
                              {t(
                                'Information about collected tips is available on the subpage'
                              )}{' '}
                              <a
                                className="link-primary"
                                href={
                                  process.env.REACT_APP_API_PUBLIC_URL +
                                  '/admin/tips'
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {process.env.REACT_APP_API_PUBLIC_URL +
                                  '/admin/tips'}
                              </a>
                              .{' '}
                              {t(
                                'If you have enabled notifications, you will receive alerts about new tips received.'
                              )}
                            </p>
                            <p>
                              <strong>{t('Enabling/Disabling Tips')}:</strong>
                            </p>
                            <p>
                              {t(
                                'By default, the tips feature is disabled for new events. To enable tips, go to the main event view and click on the event bar to expand event options. Find the "Allow Tips" switch and enable it. When tips are disabled, guests will not see the tips button, and you will see an information alert on the tips page.'
                              )}
                            </p>
                            <p>
                              <strong>{t('Required Tip (pay to add/vote)')}:</strong>
                            </p>
                            <p>
                              {t(
                                'FAQ Required tip payments Description'
                              )}
                            </p>
                            <p>
                              {t(
                                'The minimum amount is picked from a dropdown: 2, 5, 10, 20 and further, up to 200 zl.'
                              )}
                            </p>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingSix"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col11 }
                            )}
                            type="button"
                            onClick={t_col11}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Web push notifications')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col11}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'The application can display web push notifications in your browser. When you open the event view, the application may ask whether you want to enable notifications.'
                              )}
                            </p>
                            <p>
                              {t(
                                'If you are an event host (logged in to the admin view), after enabling notifications you will receive information about new tips received and about new tracks added to the list for your event.'
                              )}
                            </p>
                            <p>
                              {t(
                                'If you are a guest at a karaoke-type event, after enabling notifications you will receive information when your track is next to be played (second on the list).'
                              )}
                            </p>
                            <p>
                              {t(
                                'You can disable notifications at any time in your browser settings. If you do not consent to notifications, the application will still work, but you will not receive these alerts.'
                              )}
                            </p>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingSeven"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col13 }
                            )}
                            type="button"
                            onClick={t_col13}
                            style={{ cursor: "pointer" }}
                          >
                            {t('How to set event logo?')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col13}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'You can personalize your event by uploading a custom logo that will be displayed to all guests.'
                              )}
                            </p>
                            <p>
                              <strong>{t('How to upload:')}</strong>
                            </p>
                            <ol className="ps-2 list-group list-group-numbered">
                              <li className="list-group-item">
                                {t(
                                  'On the main event screen, find the logo/avatar image at the top of the page.'
                                )}
                              </li>
                              <li className="list-group-item">
                                {t(
                                  'Click on the camera icon that appears when you hover over the image.'
                                )}
                              </li>
                              <li className="list-group-item">
                                {t(
                                  'Select an image file from your device (JPEG or PNG format, maximum 0.5MB).'
                                )}
                              </li>
                              <li className="list-group-item">
                                {t(
                                  'The logo will be uploaded and displayed immediately to all event participants.'
                                )}
                              </li>
                            </ol>
                            <p>
                              <strong>{t('Important:')}</strong>
                            </p>
                            <ul className="ps-2">
                              <li className="list-group-item">
                                {t('Only JPEG and PNG formats are accepted.')}
                              </li>
                              <li className="list-group-item">
                                {t('Maximum file size is 0.5MB.')}
                              </li>
                              <li className="list-group-item">
                                {t(
                                  'The logo upload option is only available to event administrators.'
                                )}
                              </li>
                            </ul>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingEight"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col14 }
                            )}
                            type="button"
                            onClick={t_col14}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Song Libraries - what are they and how to use them?')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col14}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              <strong>{t('What are Song Libraries?')}</strong>
                            </p>
                            <p>
                              {t(
                                'Song Libraries allow you to create custom collections of songs that can be assigned to your events. You can create up to 6 different libraries, each containing up to 1000 songs.'
                              )}
                            </p>
                            <p>
                              <strong>{t('Where to find them?')}</strong>
                            </p>
                            <p>
                              {t(
                                'Song Libraries are available from the profile dropdown menu in the top right corner. Click on your profile icon and select "Song Library" option. You can also access them directly at'
                              )}{' '}
                              <a
                                className="link-primary"
                                href={
                                  process.env.REACT_APP_API_PUBLIC_URL +
                                  '/admin/song-libraries'
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {process.env.REACT_APP_API_PUBLIC_URL +
                                  '/admin/song-libraries'}
                              </a>
                              .
                            </p>
                            <p>
                              <strong>{t('How to use them?')}</strong>
                            </p>
                            <p>
                              {t(
                                'On the Song Libraries page, you will find two tabs - "Global Library" containing all songs in the system, and "My Libraries" where you can create and manage your custom collections. Select songs from the global library and add them to your custom libraries.'
                              )}
                            </p>
                            <p>
                              {t(
                                'To assign a library to your event, go to the main event screen and click on the event bar to expand options. Find the "Song Library" field - you can select one of your custom libraries or leave it empty. When no library is selected, guests can choose from all songs in the global library (default behavior).'
                              )}
                            </p>
                            <p>
                              <strong>{t('How to import songs from a CSV file?')}</strong>
                            </p>
                            <p>
                              {t(
                                'Go to the "My Libraries" tab and click the "Import from CSV" button. Choose the library you want to fill, pick the file and confirm with "Import". The button stays inactive until you create at least one library.'
                              )}
                            </p>
                            <p>
                              {t(
                                'The file needs two columns - artist first, title second, one song per line. A header row with "artist" and "title" is ignored. Columns may be separated by a semicolon, comma, tab or vertical bar, so files exported from Excel work as they are.'
                              )}
                            </p>
                            <p>{t('Example file content')}:</p>
                            <pre className="p-2 bg-light border rounded small">
                              {'artist;title\nQueen;Bohemian Rhapsody\nDaft Punk;Get Lucky'}
                            </pre>
                            <p>
                              {t(
                                'Limits: up to 2 MB and 5000 lines per file, up to 1000 songs in one library, and up to 60 characters for the artist and for the title. Only .csv and .txt files are accepted.'
                              )}
                            </p>
                            <p>
                              {t(
                                'After the import you will see a summary: how many songs were added to the library, how many were new to the system, how many were skipped because the library already contained them, and how many lines were rejected (empty artist or title, or a name that is too long) - with examples. Songs are matched regardless of letter case, so the same file can be imported again without creating duplicates.'
                              )}
                            </p>
                            <p>
                              {t(
                                'Rejected lines are listed one per line, up to 50 of them; above that the summary says how many of the rejected lines it is showing.'
                              )}
                            </p>
                          </div>
                        </Collapse>
                      </div>

                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="manageaccount-headingNine"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col15 }
                            )}
                            type="button"
                            onClick={t_col15}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Dedications without a song')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col15}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'A guest can send a dedication on its own, without putting any song on the list - for birthday wishes or a greeting you read out between tracks. The option is not available in karaoke mode, where the note always travels with the song the guest is going to sing.'
                              )}
                            </p>
                            <p>
                              <strong>{t('How to enable it?')}</strong>
                            </p>
                            <p>
                              {t(
                                'Click the event bar to expand the settings and turn on the "Allow dedications" switch. Right below it choose the dedication limit per guest (1 to 20) - it works like the song limit and stops one person from flooding the list.'
                              )}
                            </p>
                            <p>
                              <strong>{t('How does the guest send one?')}</strong>
                            </p>
                            <p>
                              {t(
                                'A "Add a dedication" button appears next to "Add Song To List". The guest types up to 150 characters and confirms. Once the limit is used up the button stops working until one of their dedications is removed.'
                              )}
                            </p>
                            <p>
                              <strong>{t('Who sees what?')}</strong>
                            </p>
                            <p>
                              {t(
                                'Dedications sit in their own list under the songs. A guest only sees their own; you see all of them with the name of the sender. Both you and the author can delete a dedication - deleting frees a slot in that guest\'s limit.'
                              )}
                            </p>
                            <p>
                              {t(
                                'When a tip is required for the event, a dedication costs the same as adding a song: one paid tip buys one dedication.'
                              )}
                            </p>
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col lg={4}>
                  <div className="mt-3">
                    <div className="d-flex align-items-center mb-2">
                      <div className="flex-shrink-0 me-1">
                        <i className="ri-user-settings-line fs-24 align-middle text-success me-1"></i>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="fs-16 mb-0 fw-semibold">
                          {t('Manage app')}
                        </h5>
                      </div>
                    </div>

                    <div
                      className="accordion accordion-border-box"
                      id="privacy-accordion"
                    >
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="privacy-headingOne"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col9 }
                            )}
                            type="button"
                            onClick={t_col9}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Event bar appearance')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col9}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'You can personalize the background of the event bar (the bar with the event name below the main toolbar). Click the event bar to expand the event options and scroll to the bottom of the form. Available settings'
                              )}:
                            </p>
                            <ol className="ps-2">
                              <li className="list-group-item">
                                <strong>
                                  - {t('Event Bar Background Color')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'choose a color that matches your logo, venue, or brand. You can return to the default at any time by clicking the "Reset" button.'
                                )}
                              </li>
                              <li className="list-group-item">
                                <strong>
                                  - {t('Background Transparency')}
                                </strong>{' '}
                                -{' '}
                                {t(
                                  'adjust how transparent the event bar background is. A live preview next to the slider shows exactly how the bar will look.'
                                )}
                              </li>
                            </ol>
                          </div>
                        </Collapse>
                      </div>
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id="privacy-headingOne"
                        >
                          <button
                            className={classnames(
                              "accordion-button",
                              "fw-medium",
                              { collapsed: !col12 }
                            )}
                            type="button"
                            onClick={t_col12}
                            style={{ cursor: "pointer" }}
                          >
                            {t('Profile Settings')}
                          </button>
                        </h2>
                        <Collapse
                          isOpen={col12}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <p>
                              {t(
                                'After clicking the profile icon in the top right corner, a list of subpages will expand. By selecting the "Profile" subpage, you will be taken to the settings page.'
                              )}
                            </p>
                            <p>{t('Available settings')}:</p>
                            <p>
                              <ol className="ps-2">
                                <li className="list-group-item">
                                  <strong>
                                    - {t('Social media links')}
                                  </strong>{' '}
                                  -{' '}
                                  {t(
                                    'on the subpage'
                                  )}{' '}
                                  <a
                                    className="link-primary"
                                    href={
                                      process.env.REACT_APP_API_PUBLIC_URL +
                                      '/admin/profile'
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {process.env.REACT_APP_API_PUBLIC_URL +
                                      '/admin/profile'}
                                  </a>{' '}
                                  {t(
                                    'you can set links to your social media profiles. After setting them, icons for the respective social media platforms will be displayed on the main event bar, allowing guests to easily follow you or share your event.'
                                  )}
                                </li>
                              </ol>
                            </p>
                          </div>
                        </Collapse>
                      </div>
                    </div>

                  </div>
                </Col>

              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Faqs;
